import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import { Checkbox, createFilterOptions } from '@mui/material'
import { default as TextFieldMui } from '@mui/material/TextField'
import { Autocomplete, AutocompleteProps } from './Autocomplete'

export interface OrderTypeCodesAutoCompleteProps
  extends Omit<AutocompleteProps, 'options' | 'renderInput'> {
  orderTypeCodesData: any
  selectedOrderTypeCodes: any
}

export const OrderTypeCodesAutocomplete = ({
  name,
  orderTypeCodesData,
  selectedOrderTypeCodes,
  ...rest
}: OrderTypeCodesAutoCompleteProps) => {
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
  const checkedIcon = <CheckBoxIcon fontSize="small" />

  const filterOptions = createFilterOptions({
    ignoreCase: true,
    stringify: (option: any) => option.value + option.label,
  })

  return (
    <Autocomplete
      name={name}
      multiple
      options={orderTypeCodesData}
      limitTags={3}
      disableCloseOnSelect
      disablePortal
      filterOptions={filterOptions}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={(option) => option.value}
      value={selectedOrderTypeCodes}
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginRight: 8 }}
            checked={selected}
          />
          {option?.label}
        </li>
      )}
      renderInput={(params) => (
        <TextFieldMui
          {...params}
          placeholder={
            selectedOrderTypeCodes && selectedOrderTypeCodes.length === 0
              ? 'Select Order Type Code'
              : ''
          }
        />
      )}
      {...rest}
    />
  )
}
